// src/utils/formatters.js
export const formatTimestamp = (isoString) => {
  if (!isoString) return 'unknown time';
  
  try {
	const date = new Date(isoString);
	const now = new Date();
	const diff = now - date;
	
	const minutes = Math.floor(diff / 60000);
	const hours = Math.floor(minutes / 60);
	const days = Math.floor(hours / 24);

	if (days > 0) return `${days}d ago`;
	if (hours > 0) return `${hours}h ago`;
	if (minutes > 0) return `${minutes}m ago`;
	return 'Just now';
  } catch {
	return 'unknown time';
  }
};

export const formatHandle = (handle) => {
  if (!handle) return '@unknown';
  return handle.startsWith('@') ? handle : `@${handle}`;
};

export const getProfileImageUrl = (avatarData) => {
  const DEFAULT_AVATAR = 'https://cdn.bsky.social/img/avatar/placeholder.png';
  
  if (!avatarData) return DEFAULT_AVATAR;
  
  try {
	if (avatarData.ref?.$link && avatarData.mimeType) {
	  return `https://cdn.bsky.app/img/avatar/plain/${avatarData.ref.$link}@${avatarData.mimeType}`;
	}
	return DEFAULT_AVATAR;
  } catch {
	return DEFAULT_AVATAR;
  }
};